import React, { FC } from 'react';
// package imports
import { ListCards } from '@/components/molecules/ListCards/render';
// internal imports
import block from './block.json';

/**
 * COMPONENT
 */
export const ListShop: FC<ListCardsProps> & BlockConfigs = (props) => {
	return <ListCards {...props} />;
};

ListShop.slug = block.slug;
ListShop.title = block.title;
